import React, { useState, useEffect } from "react"
import { Card, CardBody, Container, Row, Col, Spinner } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { FiMail, FiPhone, FiMapPin } from "react-icons/fi"
import { ToastContainer, toast } from "react-toastify"
import { URLS } from "../../Url"
import axios from "axios"

const ContactUs = () => {
  const [contactData, setContactData] = useState({
    email: "",
    phone: "",
    address: "",
    mapOne: "",
  })
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    fetchContactData()
  }, [])

  const fetchContactData = async () => {
    try {
      const authUser = localStorage.getItem("authUser")
      if (!authUser) throw new Error("Authentication required")

      const token = JSON.parse(authUser).token
      const response = await axios.post(
        URLS.GetContact,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      )

      if (response.data?.contactus) {
        setContactData(response.data.contactus)
      }
    } catch (error) {
      console.error("Error fetching contact data:", error)
      setError(error.message || "Failed to load contact information")
      toast.error("Failed to load contact information")
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Contact Us" />
          <div className="text-center py-5">
            <Spinner color="primary" />
            <p>Loading contact information...</p>
          </div>
        </Container>
      </div>
    )
  }

  if (error) {
    return (
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Contact Us" />
          <div className="alert alert-danger">{error}</div>
        </Container>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Bizzmate Supplier" breadcrumbItem="Contact Us" />
          <Card className="shadow-sm">
            <CardBody>
              <Row>
                <Col lg={12}>
                  <div className="text-center mb-2">
                    <h3 className="text-primary">Contact Information</h3>
                  </div>
                  <hr></hr>
                  <Row >
                    <Col md={4}>
                      <Card className="border-0 shadow-none text-center h-100">
                        <CardBody>
                          <div className="bg-soft-primary rounded mb-2 d-inline-block">
                            <FiMail className="text-primary" size={24} />
                          </div>
                          <h5>Email</h5>
                          <p className="text-muted mb-0">
                            {contactData.email || "Not provided"}
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="border-0 shadow-none text-center h-100">
                        <CardBody>
                          <div className="bg-soft-success rounded  mb-2 d-inline-block">
                            <FiPhone className="text-success" size={24} />
                          </div>
                          <h5>Phone</h5>
                          <p className="text-muted mb-0">
                            {contactData.phone || "Not provided"}
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={4}>
                      <Card className="border-0 shadow-none text-center h-100">
                        <CardBody>
                          <div className="bg-soft-warning rounded  mb-2 d-inline-block">
                            <FiMapPin className="text-warning" size={24} />
                          </div>
                          <h5>Address</h5>
                          <p className="text-muted mb-0">
                            {contactData.address || "Not provided"}
                          </p>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <hr></hr>
                  <h5 className="mb-3">Description: </h5>
                  <p>{contactData.description}</p>
                  <hr></hr>
                  <div className="mt-2">
                    <h5 className="mb-3">Our Location</h5>
                    {contactData.mapOne ? (
                      <div className="ratio ratio-16x9 rounded overflow-hidden border">
                        <iframe
                          src={contactData.mapOne}
                          title="Our Location"
                          allowFullScreen
                          loading="fast"
                        ></iframe>
                      </div>
                    ) : (
                      <div className="alert alert-info">
                        Map location not available
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
        <ToastContainer position="top-right" autoClose={5000} />
      </div>
    </React.Fragment>
  )
}

export default ContactUs
